import React, {useState} from 'react';
import Button from '@mui/material/Button';
import {Owner,Book,BookOption} from './Inc';
import BookInputTab1 from './BookInputTab1';
import BookInputTab2 from './BookInputTab2';
import BookInputTab3 from './BookInputTab3';
import Ajax from './Ajax';

interface Props {
    owner:Owner,
    book:Book,
    option:BookOption,
    cache_key:string,
    save():void,
    update(option:BookOption):void,
    edit(flag:boolean):void,
    tabId?:number,
}

const BookInputTabs = (props:Props)=> {
    Ajax.setEditorId(props.owner.owner_id);
    const tabs:string[] = ["一括編集","微調整","アップロード"];
    let defTabId = 1;
    if( props.tabId ){
        defTabId = props.tabId;
    }
    const [states,setStates] = useState({
        tabId:defTabId,
    });
    const changeTab = (e: React.MouseEvent<HTMLElement>) => {
        if( e.currentTarget.dataset.id ){
            if(states.tabId!==parseInt(e.currentTarget.dataset.id)){
                if(e.currentTarget.dataset.id==="2"){
                    props.edit(true);
                } else {
                    props.edit(false);
                }
                setStates({...states,tabId:parseInt(e.currentTarget.dataset.id)});
            }
        }
    };
    const updateSource = (option:BookOption)=>{
        setStates({...states,tabId:1});
        props.update(option);
    }

    return (
        <div id="book_input_text_tabs">
            <div className="tabs">
                {tabs.map( (name:string,index:number)=>{
                    const key = "tab" + String(index+1);
                    let cl = "tab";
                    if( index+1===states.tabId ){
                        cl = cl + " tabCurrent";
                    }
                    if( index===2 ){
                        cl = cl + " tabLast";
                    }
                    return (
                        <div key={key} className={cl} onClick={changeTab} data-id={index+1}>{name}</div>
                    )
                })}
            </div>
            {states.tabId===1 &&
            <BookInputTab1 book={props.book} option={props.option} owner={props.owner} update={props.update} save={props.save}/>
            }
            {states.tabId===2 &&
            <BookInputTab2 save={props.save}/>
            }
            {states.tabId===3 &&
            <BookInputTab3 option={props.option} owner={props.owner} update={updateSource} cache_key={props.cache_key}/>
            }
        </div>
	);
}

export default BookInputTabs;
